<template>
  <!-- MDH -->
    <div class="unleashed">

      <cq-header headertext="MANAN UNLEASHED"></cq-header>
      
        <cqtextimagesection direction = "R" :imagesrc="images.unleashed">
          
          <cq-paratext> Manan sharpened his entrepreneurship skills at a young age.  </cq-paratext>
          <cq-paratext> He founded <b class="red"> Unleashed Consulting </b> at 24 which provides practical solutions in Systems Designing &amp; Implementation, Operational Excellence, Team Alignment, Management Consulting, Project Management, and Executive Coaching. </cq-paratext>
          <cq-paratext> He is a <b class="red"> Business Consultant &amp; Productivity Coach </b> to CEOs of Public Ltd. Companies &amp; SMEs, Film Directors, Professionals, Businessmen, Doctors, CAs, Artistes &amp; people from varied backgrounds. </cq-paratext>
          <cq-paratext> He is a <b class="red"> Chartered Accountant </b> and an IIM Alumnus from <b class="red"> IIM - Calcullta </b> (Sales &amp; Marketing) and <b class="red"> IIM-Kozhikode </b> (Project Management). </cq-paratext>

        </cqtextimagesection>
    </div>
    <!-- End MDH -->
</template>

<script>
import CQPara from '../../components/ui/CQPara.vue'
import CQHeader from '../../components/ui/CQHeader.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Images
import unleashed from '../../assets/image/mv/unleashed.png'

export default {
    components: {
        'cq-header' : CQHeader,
        'cq-paratext' : CQPara,
        'cqtextimagesection': CQTextImageSection
    },
    data() {
        return {
            images: { 
                unleashed
            }
        }
  }
}
</script>

<style scoped>
.unleashed >>> .red{
  color: var(--primary-color);
}


@media only screen and (max-width: 992px){
  /* .unleashed >>> #manan-img{
    position: relative;
    top: 0;
    left: 0;
  } 
    
  .unleashed >>> #playbtn{
    width: 13% !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .unleashed >>> #showhow{
    position: absolute;
    bottom: 1%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .unleashed >>> .mdh1{
    padding: 10px !important;
  } */

  .unleashed >>> .display-none{
    display: none;
  }
  
  .unleashed >>> .tgg-img{
    padding-bottom: 10%;
  }
}

/* Desktop View */
@media only screen and (min-width: 992px){
  .unleashed >>> .grey{
    background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA);
    margin-bottom: 20px;
  }

  .unleashed >>> .mdh1{
    padding-left: 104.5px !important;
    padding-right: 30px !important;
    padding-top: 45px;
  }
  
  .unleashed >>> .mdh2{
    padding-right: 0 !important;
  }
  
  .unleashed >>> #manan-img{
    padding: 30px 0 0 30px;
  }
  
  .unleashed >>> #playbtn{
    position: absolute;
    top: 270px;
    left: 320px; 
    width: 15% !important;
  }

  .unleashed >>> #showhow{
    position: absolute;
    left: 210px;
    z-index: 9999;
    bottom: 0;
  }

  .unleashed >>> .top-left-borders{
    border-left: 4px solid var(--primary-color);
    border-top: 4px solid var(--primary-color);
    width: 150px;
    height: 150px;
    position: absolute;
  }

  .unleashed >>> .gg1{
    /* padding-left: 10px !important; */
    text-align: center;
  }

  .unleashed >>> .tgg-img{
    padding-top: 0 !important;
    margin-top: -25px;
    margin-bottom: 30px;
    z-index: 1;
    max-width: 80%;
    padding: 0 !important;
  }

  .unleashed >>> .behind-header{
    margin-bottom: 0 !important;
    z-index: 3;
  }

  .unleashed >>> .gg2 {
    padding-top: 80px;
    padding-right: 104.5px !important;
  }
}

</style>